module.exports = __webpack_public_path__ + "media/home-video-bg.e3c94d64.mp4";